import React, { useEffect, useRef } from 'react'
import { HiCheckCircle } from 'react-icons/hi'

// Short-lived success message. Render it when `message` is set; it calls onDone after `duration` ms.
const Toast = ({ message, onDone, duration = 3000 }) => {
    const doneRef = useRef(onDone)
    doneRef.current = onDone

    useEffect(() => {
        if (!message) return
        const timer = setTimeout(() => doneRef.current(), duration)
        return () => clearTimeout(timer)
    }, [message, duration])

    if (!message) return null
    return (
        <div className='mv-toast' role='status' aria-live='polite'>
            <HiCheckCircle /> {message}
        </div>
    )
}

export default Toast
